export default __webpack_public_path__ + "static/media/HelveticaNeue.3354ee47.woff";